import React from 'react';
import { FormInput, Search, ShieldCheck, Truck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function HowItWorks() {
  const { t } = useLanguage();
  
  const steps = [
    {
      number: '01',
      title: t('how.step1_title'),
      description: t('how.step1_desc'),
      icon: FormInput,
    },
    {
      number: '02',
      title: t('how.step2_title'),
      description: t('how.step2_desc'),
      icon: Search,
    },
    {
      number: '03',
      title: t('how.step3_title'),
      description: t('how.step3_desc'),
      icon: ShieldCheck,
    },
    {
      number: '04',
      title: t('how.step4_title'),
      description: t('how.step4_desc'),
      icon: Truck,
    },
  ];

  return (
    <section id="saadan-fungerer-det" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-black italic text-[#293e30] tracking-tight mb-3 uppercase">
            {t('how.title')}
          </h2>
          <p className="text-base md:text-lg text-slate-600">
            {t('how.desc')}
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-0 relative">

          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={index} 
                className="relative z-10 flex flex-col items-center md:items-start text-center md:text-left group py-6 md:py-4 px-4 md:px-6 border-b md:border-b-0 md:border-r last:border-b-0 md:last:border-r-0 border-slate-100"
              >
                {/* Icon (No background, no borders, perfectly aligned) */}
                <div className="h-10 w-10 flex items-center justify-center text-slate-900 group-hover:text-slate-600 transition-colors duration-300 mb-3">
                  <Icon className="h-6 w-6" />
                </div>

                {/* Content */}
                <h3 className="text-base font-bold text-slate-900 mb-2 group-hover:text-[#293e30] transition-colors uppercase tracking-wide">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
